import { SurveyTitles } from "@prisma/mongoClient";

export default SurveyTitles;
